/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';

// @TODO use matchmedia instead
@Injectable()
export class DeviceDetectionService {
  public isDevice: boolean;
  public isTablet: boolean;
  public isMobile: boolean;
  public isDesktop: boolean;

  constructor() {
    this.isDevice = this.checkMobile() || this.checkTablet();
    this.isTablet = this.checkTablet();
    this.isMobile = this.checkMobile();
    this.isDesktop = !this.checkMobile() && !this.checkTablet();
  }

  /**
   * Check the mobile type
   * @returns boolean
   */
  public checkMobile(): boolean {
    let isMobile = false;

    if (navigator.userAgent.match(/BlackBerry|Mobile|iPhone|iPod|Opera Mini|IEMobile/i)) {
      isMobile = true;
    }

    if (navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i)) {
      isMobile = true;
    }

    if (navigator.userAgent.match(/Tablet|iPad/i)) {
      isMobile = false;
    }

    return isMobile;
  }

  /**
   * Check whether device is tablet or not.
   * @returns boolean
   */
  public checkTablet(): boolean {
    let isTablet = false;

    // Adding below condition to check for IE browser
    if (navigator.userAgent.indexOf('MSIE ') > 0 || navigator.userAgent.indexOf('Trident/') > 0) {
      return false;
    }

    if (navigator.userAgent.match(/Android|Tablet|iPad/i)) {
      isTablet = true;
    }

    if (navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i)) {
      isTablet = false;
    }

    return isTablet;
  }
}
